export default __webpack_public_path__ + "static/property2-6b4f468c0d1a5026eaa46e815863f42b.png";